<script setup lang="ts">
import { computed, onMounted, ref } from 'vue'
import update from './mixins/update'
import { useAppStore } from './store/app'
import { storeToRefs } from 'pinia'
import router from './router'

update.setup()

const appStore = useAppStore()
const { userData } = storeToRefs(appStore)

const routeMeta = ref(router.currentRoute.meta || {})

onMounted(() => {
  routeMeta.value = router.currentRoute.meta || {}
})

router.afterEach((to) => {
  routeMeta.value = to.meta || {}
})

const hideGuestBar = computed(() => {
  return !userData.value && routeMeta.value.hideGuestBar === true
})
</script>

<template>
  <v-app>
    <TheAppBarUser v-if="userData" />

    <TheAppBarGuest v-else-if="!hideGuestBar" />

    <v-main v-if="userData">
      <router-view />
    </v-main>

    <router-view v-else />

    <TheCookies />

    <TheAppSnackbar />
  </v-app>
</template>

<style>
@media print {

  .v-main {
    padding: 0 !important;
    margin: 0 !important;
  }
}
</style>
